import { useEffect, useRef, useState } from "react";
import Loader from "src/components/Loader";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import { useUpdateEffectDebounce } from "src/hooks/useDebounce";

interface SelectSearchProps extends Translation {
	placeholder?: string;
	onChange: (search: string) => void;
	loading?: boolean;
	value?: string;
	autoFocus?: boolean;
}

const SelectSearch = ({
	t,
	placeholder,
	onChange,
	loading,
	value,
	autoFocus,
}: SelectSearchProps) => {
	const input = useRef<HTMLInputElement>(null);
	const [search, setSearch] = useState<string>(value || "");
	useUpdateEffectDebounce(search, 500, (value) => {
		onChange(value);
	});

	useEffect(() => {
		if (autoFocus) {
			// setTimeout(() => {
			// 	if (input?.current) {
			// 		console.log("FOCUS");
			// 		input.current.focus();
			// 	}
			// }, 200);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="relative">
			<div className="pl-4 absolute top-0 bottom-0 left-0 items-center flex pointer-events-none">
				<div className="w-4">
					<i className="far fa-search text-[14px]"></i>
				</div>
			</div>
			<input
				ref={input}
				name="search"
				onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
					e.stopPropagation()
				}
				placeholder={placeholder || t("placeholder")}
				className="py-3 pl-10 pr-4 rounded-md focus:bg-gray w-full placeholder-placeholder"
				required
				value={search}
				onChange={(e) => {
					e.preventDefault();
					e.stopPropagation();
					setSearch(e.target.value);
				}}
			/>
			{loading && (
				<div className="pr-4 absolute top-0 bottom-0 right-0 items-center flex pointer-events-none">
					<div className="w-4">
						<Loader />
					</div>
				</div>
			)}
		</div>
	);
};

SelectSearch.locale = {
	nl: {
		placeholder: "Zoeken...",
	},
	en: {
		placeholder: "Search...",
	},
};

export default withTranslation(SelectSearch);
